// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GenerateAndSavePdfFromHtmlRequest {
    static getAttributeTypeMap() {
        return GenerateAndSavePdfFromHtmlRequest.attributeTypeMap;
    }
}
GenerateAndSavePdfFromHtmlRequest.discriminator = undefined;
GenerateAndSavePdfFromHtmlRequest.additionalProperties = false;
GenerateAndSavePdfFromHtmlRequest.attributeTypeMap = [
    {
        "name": "type",
        "baseName": "type",
        "type": "number"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GeneratePdfFromHtmlRequest"
    },
];
//# sourceMappingURL=generateAndSavePdfFromHtmlRequest.js.map